function pdfPreviewPath(filename: string) {
  return `/${filename}#view=FitH&toolbar=0`;
}

function pdfDownloadPath(filename: string) {
  return `/${filename}`;
}

export const resumeAsset = {
  id: "resume",
  previewPath: pdfPreviewPath("resume.pdf"),
  downloadPath: pdfDownloadPath("resume.pdf"),
  downloadName: "Md-Sakibul-Islam-Resume.pdf",
};

export const certificateAssets = [
  {
    id: "next-level",
    title: "Next Level Web Development Course",
    provider: "Programming Hero",
    year: "2024",
    previewPath: pdfPreviewPath("next-level.pdf"),
    downloadPath: pdfDownloadPath("next-level.pdf"),
    downloadName: "Next-Level-Web-Development-Course.pdf",
  },
  {
    id: "level-one",
    title: "Complete Web Development Course",
    provider: "Programming Hero",
    year: "2022",
    previewPath: pdfPreviewPath("level-one.pdf"),
    downloadPath: pdfDownloadPath("level-one.pdf"),
    downloadName: "Complete-Web-Development-Course.pdf",
  },
] as const;

export type CertificateAsset = (typeof certificateAssets)[number];

export function getPdfPreviewUrl(url: string | undefined | null): string {
  if (!url) return "/resume.pdf";
  if (url.startsWith("/") && !url.startsWith("//")) {
    return url;
  }
  return `/api/pdf-proxy?url=${encodeURIComponent(url)}`;
}

export function getPdfDownloadUrl(url: string | undefined | null, filename?: string): string {
  if (!url) return "/resume.pdf";
  if (url.startsWith("/") && !url.startsWith("//")) {
    return url;
  }
  return `/api/pdf-proxy?url=${encodeURIComponent(url)}&download=1${
    filename ? `&filename=${encodeURIComponent(filename)}` : ""
  }`;
}
